export const FormatDate = (newDate) => {
  var a = new Date(parseInt(newDate));
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var year = a.getFullYear().toString().substr(-2);
  var month = months[a.getMonth()];
  let date = a.getDate();
  var time = a.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });

  var dateFormat = date + " " + month + " " + year;

  return dateFormat + " - " + time;
};


export const FormatTimeOnly = (FormateDate) => {
  var a = new Date(parseInt(FormateDate));
  var time = a.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" });
  return  time;
};


export const FormatDateOnly = (FormateDate) => {
  var a = new Date(parseInt(FormateDate));
  var monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  var yearName = a.getFullYear().toString().substr(-2);
  var monthName = monthNames[a.getMonth()]; // Subtract 1 since month numbers are zero-based
  let date = a.getDate();
  var formattedDate = date > 9 ? date : "0"+date + " " + monthName + " " + yearName;
  return formattedDate;
};


export const timeAgo = (timestamp)=>{
  const now = Date.now();
  const secondsAgo = Math.floor((now - timestamp) / 1000);

  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;
  const year = 365 * day;

  if (secondsAgo < minute) {
    return `${secondsAgo} seconds ago`;
  } else if (secondsAgo < hour) {
    const minutesAgo = Math.floor(secondsAgo / minute);
    return `${minutesAgo} minute${minutesAgo > 1 ? "s" : ""} ago`;
  } else if (secondsAgo < day) {
    const hoursAgo = Math.floor(secondsAgo / hour);
    return `${hoursAgo} hour${hoursAgo > 1 ? "s" : ""} ago`;
  } else if (secondsAgo < month) {
    const daysAgo = Math.floor(secondsAgo / day);
    return `${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
  } else if (secondsAgo < year) {
    const monthsAgo = Math.floor(secondsAgo / month);
    return `${monthsAgo} month${monthsAgo > 1 ? "s" : ""} ago`;
  } else {
    const yearsAgo = Math.floor(secondsAgo / year);
    return `${yearsAgo} year${yearsAgo > 1 ? "s" : ""} ago`;
  }
}


export const yieldtimeAgo = (timestamp)=>{
  const now = Date.now();
  const secondsAgo = Math.floor((now - timestamp) / 1000);

  const minute = 60;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;
  const year = 365 * day;

  if (secondsAgo < minute) {
    return `${secondsAgo} seconds`;
  } else if (secondsAgo < hour) {
    const minutesAgo = Math.floor(secondsAgo / minute);
    return `${minutesAgo} minute${minutesAgo > 1 ? "s" : ""}`;
  } else if (secondsAgo < day) {
    const hoursAgo = Math.floor(secondsAgo / hour);
    return `${hoursAgo} hour${hoursAgo > 1 ? "s" : ""}`;
  } else if (secondsAgo < month) {
    const daysAgo = Math.floor(secondsAgo / day);
    return `${daysAgo} day${daysAgo > 1 ? "s" : ""}`;
  } else if (secondsAgo < year) {
    const monthsAgo = Math.floor(secondsAgo / month);
    return `${monthsAgo} month${monthsAgo > 1 ? "s" : ""}`;
  } else {
    const yearsAgo = Math.floor(secondsAgo / year);
    return `${yearsAgo} year${yearsAgo > 1 ? "s" : ""}`;
  }
}
